import memoryStorage from './storage/Memory';

class ClientStore {
  #store: Storage;

  #defaultValue: unknown;

  constructor(storage: Storage, defaultValue: unknown = null) {
    this.#store = storage;
    this.#defaultValue = defaultValue;
  }

  try<T>(operation: (storage: Storage) => T): T {
    try {
      return operation(this.#store);
    } catch {
      this.#store = memoryStorage;
      return operation(this.#store);
    }
  }

  get(key: string, defaultValue?: unknown) {
    const value = this.try((storage) => storage.getItem(key));

    if (value) {
      return JSON.parse(value);
    }

    if (defaultValue) {
      return defaultValue;
    }

    return this.#defaultValue;
  }

  set(key: string, value: unknown) {
    const serializedValue = JSON.stringify(value);
    this.try((storage) => storage.setItem(key, serializedValue));
  }

  remove(key: string) {
    this.try((storage) => storage.removeItem(key));
  }
}

export default ClientStore;
